/**
 * Check if a type is 3D-only (placeholder images, no real 2D sprites).
 */
function is3DOnly(type) {
  return type?.mouthClosed?.includes('3d_placeholder')
}

/**
 * Check if a type has 3D capability (placeholder 3D type OR has a 3D model uploaded).
 */
export function is3DType(type) {
  if (!type) return false
  if (type.renderMode === '3d') return true
  if (is3DOnly(type)) return true
  return false
}

/**
 * Check if a type has 2D capability (has real sprite images, not just placeholders).
 */
export function is2DType(type) {
  if (!type) return false
  // Has real 2D sprites (not placeholder)
  return !is3DOnly(type)
}

/**
 * Filter critter types to those usable in 2D mode.
 * Includes types with real sprite images (even if they also have a 3D model).
 */
export function get2DTypes(critterTypes) {
  const result = {}
  for (const [key, type] of Object.entries(critterTypes)) {
    if (is2DType(type)) {
      result[key] = type
    }
  }
  return result
}

/**
 * Filter critter types to those usable in 3D mode.
 * Includes 3D placeholder types AND any type that has a 3D model uploaded.
 */
export function get3DTypes(critterTypes) {
  const result = {}
  for (const [key, type] of Object.entries(critterTypes)) {
    if (is3DType(type)) {
      result[key] = type
    }
  }
  return result
}
